










import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class Counter extends Vue {
  count: number = null

  @Prop({ type: Number, default: 0 }) initialCount!: number
  @Prop({ type: String, default: 'turtoise' }) color: string
  @Prop({ type: Boolean, default: false }) disabled: boolean

  @Watch('initialCount', { immediate: true })
  updateCount(count) {
    this.count = count
    this.$emit('count', this.count)
  }

  get counterClasses() {
    const classes = []
    classes.push(`is-${this.color}`)
    return classes
  }

  increment() {
    this.count++
    this.$emit('count', this.count)
  }

  decrement() {
    this.count = this.count > 0 ? this.count -= 1 : this.count
    this.$emit('count', this.count)
  }
}
